import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { MIN_STEPS_FOR_SEARCH } from '../constants/searchSteps';
import ArrowSearchIcon from '../../../../img/treatment/Arrow-search.svg';

/**
 * Search button component with dynamic state based on completed steps
 * @param {Object} props - Component props
 * @param {number} props.completedStepsCount - Number of completed steps
 * @param {boolean} props.areAllRequiredStepsValid - Whether all required steps are valid
 * @param {Function} props.onSearch - Search handler function
 * @returns {JSX.Element} SearchButton component
 */
const SearchButton = ({ completedStepsCount, areAllRequiredStepsValid, onSearch }) => {
  const { t } = useTranslation('treatment-search');

  const isSearchEnabled = areAllRequiredStepsValid && completedStepsCount >= MIN_STEPS_FOR_SEARCH;

  return (
    <div className="flex justify-center px-4">
      <Button
        type="primary"
        size="large"
        onClick={onSearch}
        disabled={!isSearchEnabled}
        style={{
          backgroundColor: isSearchEnabled ? '#A0D911' : undefined,
          borderColor: isSearchEnabled ? '#7CB305' : undefined,
        }}
        className="font-medium flex items-center gap-2"
      >
        <img src={ArrowSearchIcon} alt="" className={`w-6 h-6 ${!isSearchEnabled ? 'opacity-40' : ''}`} />
        {t('actions.search')}
      </Button>
    </div>
  );
};

export default SearchButton;
